const i18n = {
  'form': {
    'isRequired': '欄位為必填',
    'needContact': '最少必須提供一種聯絡方式',
    'dateFormatError': '無效的日期格式',
    'dateAfterToday': '日期不得大於今日',
  }
};
export default i18n;
